// home slideshow
(function () {
    if (!document.querySelector(".js-slideshow-slider")) {
        return;
    }

    const mySwiper = new Swiper(".js-slideshow-slider", {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        speed: 800,
        autoplay: true,
        navigation: false,
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
        },
        hashNavigation: {
            replaceState: true,
            watchState: true,
        },
    });

    document.body.addEventListener("click", function (e) {
        if (
            e.target.nodeName == "IMG" &&
            e.target.parentElement.classList.contains("swiper-slide")
        ) {
            mySwiper.slideNext();
            e.preventDefault();
        }
    });
})();

// product slideshow
(function () {
    const selectors = {
        gallery: {
            container: "[data-product-modal-gallery]",
            closeButton: ".js-product-modal-galleryc-close",
            trigger: ".js-product-modal-gallery-trigger"
        }
    }
    const classes = {
        open: "open",
        active: "active",
        overflowHidden: "overflow-hidden"
    }

    const gallery = document.querySelector(selectors.gallery.container);

    if (!gallery) {
        return null;
    }

    document.addEventListener("click", (event) => {
        if (event.target.closest(selectors.gallery.trigger)) {
            openModalGallery();
        }

        if (event.target.closest(selectors.gallery.closeButton)) {
            closeModalGallery();
        }
    })

    function openModalGallery() {
        gallery.classList.add(classes.open)
        document.body.classList.add(classes.overflowHidden);
    }

    function closeModalGallery() {
        gallery.classList.remove(classes.open);
        document.body.classList.remove(classes.overflowHidden);
    }

    const closeButton = document.querySelector(selectors.gallery.closeButton);

    closeButton.addEventListener("click", () => {
        closeModalGallery();
    });
})();

const readMoreBtn = document.querySelector(".read-more-btn");
const productDesc = document.querySelector(".product__desc");

if (readMoreBtn) {
    readMoreBtn.addEventListener("click", () => {
        productDesc.classList.toggle("expand");
        readMoreBtn.classList.add("hidden");
    });
}


const dropdownBtn = document.querySelector(".dropdown-container button");
const dropdownLinks = document.querySelector(".dropdown-container .links");

if (dropdownBtn && dropdownLinks) {
    dropdownBtn.addEventListener("click", (e) => {
        dropdownLinks.classList.toggle("active");
    });
}
document.addEventListener("click", (e) => {
    if (!e.target.classList.contains("dropdown")) {
        dropdownLinks.classList.remove("active");
    }
});

(function () {
    const annoucementBar = document.querySelector(".js-annoucement-bar");

    if (!annoucementBar) {
        return null;
    }
    const root = document.querySelector(":root");
    
    let annoucementBarHeight = annoucementBar.offsetHeight * -1;
    root.style.setProperty("--annoucement-bar-height", annoucementBarHeight + "px");

    window.addEventListener("resize", () => {
        let annoucementBarHeight = annoucementBar.offsetHeight * -1;
        
        root.style.setProperty("--annoucement-bar-height", annoucementBarHeight + "px");
    }); 
})();

class Slider {
    constructor(container, options) {
        this.container = container;

        this.options = {
            slidesPerView: "auto",
            spaceBetween: 0,
            navigation: false,
            pagination: false,
            on: {
                afterInit: () => {
                    this.container.classList.add("initialized");
                }
            },
            ...options
        };

        this.init();
    }

    init() {
        if (!this.container) {
            return null;
        }

        this.slider = new Swiper(this.container, this.options);
    }

    destroy(deleteInstance = false, clearStyles = false) {
        if (!this.slider) {
            return null;
        }

        this.slider.destroy(deleteInstance, clearStyles);
    }
}

(function () {
    const cookiesAlert = document.querySelector("[data-cookies-alert]");

    function setCookie(cookieName, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cookieName) {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    const cookiesAgree = !!getCookie("cookiesPolicyAccepted");

    if (cookiesAlert) {
        if (cookiesAgree != true) {
            cookiesAlert.classList.remove("hidden");
        }
        
        const cookiesButton = document.querySelector("[data-cookies-alert-button]");

        cookiesButton.addEventListener("click", () => {
            setCookie("cookiesPolicyAccepted", true, 30);
            cookiesAlert.classList.add("hidden");
        })
    }
})();

(function () {
    const featuredSliders = document.querySelectorAll(".js-featured-collection-slider");

    if (!featuredSliders.length) {
        return null;
    }

    featuredSliders.forEach(slider => {
        new Slider(slider);
    })
})();